<script lang="ts">
export default {
  name: 'ExportList',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { AppState } from '@/store';
import { DownloadTower, FileType } from '@/utilities/tower/v2/Download';
import { TowerInfo } from './types/TowerVisualizerPage';

const towerInfo = inject<TowerInfo>('towerInfo');

// ---------------
// reactive data
// ---------------
const store = useStore<AppState>();

// ----------
// computed
// ----------
const exportListShowing = computed<boolean | undefined>(() => {
  return store?.state.towerVisualizerState.showExportOptions;
});

// ----------
// handlers
// ----------
function handleDownload(fileType: FileType): void {
  if (towerInfo?.canvas?.value) {
    DownloadTower(towerInfo?.canvas.value, fileType);
  }
  store?.commit(StoreMutationType.SHOW_VISUALIZER_EXPORT_OPTIONS, false);
}
</script>

<template>
  <div v-show="exportListShowing">
    <ul class="export-menu tw:pointer-events-auto tw:opacity-95 tw:list-none tw:py-2 tw:px-0 tw:rounded tw:shadow-lg">
      <li>
        <button
          class="export-menu-option tw:w-full tw:text-left tw:font-bold tw:py-2 tw:px-4 tw:transition-colors tw:duration-100"
          @click="handleDownload(FileType.SVG)"
        >
          Export as SVG
        </button>
      </li>

      <li>
        <button
          class="export-menu-option tw:w-full tw:text-left tw:font-bold tw:py-2 tw:px-4 tw:transition-colors tw:duration-100"
          @click="handleDownload(FileType.PNG)"
        >
          Export as PNG
        </button>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.export-menu {
  background-color: var(--tower-v2-context-menu-bg-color);
}

.export-menu-option {
  color: #ced4da;
}

.export-menu-option:hover {
  background-color: var(--tower-v2-context-menu-bg-color-hover);
}
</style>
